import { Instance, types } from 'mobx-state-tree';
import { withSetPropAction } from '@/models/helpers/withSetPropAction';
interface CommonStaticErrorModalVo {
  errorMsg: string;
  open: boolean;
  title?: string;
  btnText?: string;
  onClose: () => void;
}
/**
 * 前端静态 UI 状态
 *
 */
export const StaticStoreModel = types
  .model('StaticStore')
  .props({
    commonStaticErrorModal: types.frozen<CommonStaticErrorModalVo>({
      errorMsg: '',
      open: false,
      onClose: () => {},
    }),
  })
  .views((self) => ({}))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    setCommonStaticErrorModal(data: CommonStaticErrorModalVo) {
      self.commonStaticErrorModal = data;
    },
  }));

export interface StaticStoreModel extends Instance<typeof StaticStoreModel> {}
